import { useCallback, useEffect, useMemo, useState } from 'react';

export interface StackConfig<Data, Value> {
  data: Data[];
  getValue: (data: Data) => Value;
  hasData?: (data: Data) => boolean;
  label?: string;
  unit?: string;
  primaryColor: string;
  legendColor?: string;
  cursorColor?: string;
}
export function useStackInfo<
  Data,
  Value,
  Stack extends StackConfig<Data, Value>,
>(stacks: Stack[]) {
  const visibleData = useMemo(
    () =>
      stacks.filter(({ hasData, data }) =>
        data.some((value) => hasData?.(value)),
      ),
    [stacks],
  );
  const defaultActiveSeries = useMemo(
    () => Array<boolean>(visibleData.length).fill(true),
    [visibleData.length],
  );
  const [activeSeries, setActiveSeries] = useState(defaultActiveSeries);
  useEffect(() => setActiveSeries(defaultActiveSeries), [defaultActiveSeries]);
  const toggleSeries = useCallback(
    (i: number) => {
      const newActiveSeries = [...activeSeries];
      newActiveSeries[i] = !newActiveSeries[i];
      if (newActiveSeries.some((s) => s)) {
        setActiveSeries(newActiveSeries);
      }
    },
    [activeSeries],
  );

  return { stacks: visibleData, activeSeries, toggleSeries };
}
